export default {
  name: 'End-user identity |||| End-user identities',
  subtitle: 'All identities linked to individual and business profiles',
  tabs: {
    authMethods: 'Auth methods',
    identityLocks: 'Identity locks',
    authLogs: 'Auth logs',
    devicesAndKeys: 'Devices & keys',
  },
  fields: {
    name: 'Name',
    username: 'Username',
    emailAddress: 'Email address',
    phoneNumber: 'Phone number',
    withDeleted: 'With deleted',
    authenticationMethods: 'Authentication methods',
    linkedProfiles: 'Linked profiles',
    goToProfile: 'Go to profile',
    goToTeamMember: 'Go to team member',
    activeIdentityLocks: 'Active identity locks',
    addLock: 'Add lock',
    startDatetime: 'Start datetime',
    endDatetime: 'End datetime',
    reason: 'Reason',
    actor: 'Actor',
    outOf: 'out of',
    INDIVIDUAL: 'Individual',
    BUSINESS: 'Business',
    status: 'Status',
    kycLevel: 'KYC Level',
    kybLevel: 'KYB Level',
    solution: 'Solution',
    employee: 'Team member',
  },
};
